import GenInfo from "./personal/gen-info";
import Identities from "./personal/identities";
import Address from "./personal/address";
const Personal = () => {
  return (
    <>
      <GenInfo />
      <Identities />
      <Address />
    </>
  );
};

export default Personal;
